import { axiosbaseurl } from './config';
import React from 'react';
import { createContext, useContext, useEffect, useState } from 'react';
import secureLocalStorage from 'react-secure-storage';

const RolesContext = createContext();

export const usePermissionData = () => {
    return useContext(RolesContext);
};

export const AppContext = ({ children }) => {

    const [permissions, setPermisssions] = useState([])
    const [loginStatus, setLoginStatus] = useState(false)

    const credential = secureLocalStorage.getItem("User")
    
    useEffect(() => {
        if (credential)
            getStaffInfo()
    }, [credential])

    async function getStaffInfo() {

        await axiosbaseurl.get(`roles-and-permissions/get-permissions`)
            .then(res => {
                setPermisssions(JSON.parse(res?.data?.permissions))
            })
            .catch((err) => console.log(err))
    }

    const checkAccess = (mod_id, type) => {
        if (!permissions || permissions.length === 0) 
            getStaffInfo();

        const results = permissions?.some(temp => {
            // Split each string into an array of permissions
            const permissionArray = temp.split(',');
    
            // Check if mod_id matches the first element (index 0), and the permission at the given type index is 1
            return permissionArray[0] == mod_id && permissionArray[type] == '1';
        });
        return results
    }


    return (
        <RolesContext.Provider value={{ permissions, checkAccess, loginStatus, setLoginStatus }}>
            {children}
        </RolesContext.Provider>
    );
};